import AdminCoinsContainer from "../../components/adminCoinsGiving/AdminCoinsContainer";
import NavLinksAdmin from "../../components/navlinksAdmin/NavLinksAdmin";

const AdminCoinsGiving = () => {
  return (
    <div className="inside-page-container-blk">
      <div className="admin-page-main-container">
        <NavLinksAdmin />
        <div>
          <AdminCoinsContainer />
        </div>
      </div>
    </div>
  );
};

export default AdminCoinsGiving;
